import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './PropertyEstimate.scss';
import PropertyEstimate from './PropertyEstimate';
import {getFetchingFromState, getSaleAvm} from 'lib/PropertyUtils';
import {PROPERTY_AVM_FIELDS} from 'lib/Commons';

const mapStateToProps = (state, ownProps) => {
  const {featureFlags: {rapidSearchEnabled}, reportType: {value: reportTypeValue}} = state;
  const propertyDetail = ownProps.propertyDetail ?? state.propertyDetail;

  const isLoading = !!rapidSearchEnabled && getFetchingFromState({
    propertyId: propertyDetail.propertyId,
    state,
    updateFields: PROPERTY_AVM_FIELDS,
  });
  const isRental = 'rental' === reportTypeValue;
  let avm;
  avm = isRental ? (
    propertyDetail.rentalAvm
  ) : (
    getSaleAvm(propertyDetail)
  );
  return {
    ...ownProps,
    avm,
    isRental,
    isLoading,
  };
};

const mapDispatchToProps = () => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const PropertyEstimateContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PropertyEstimate);

export { PropertyEstimateContainer, PropertyEstimate };

PropertyEstimateContainer.propTypes = {
  propertyDetail: PropTypes.shape({
    propertyAvm: PropTypes.object,
    rentalAvm: PropTypes.object,
  }),
};
export default PropertyEstimateContainer;